import AdminLayout from '../../components/layout/AdminLayout'
import AdminContentLayout from '../../components/layout/AdminContentLayout'
import IndividualDashboardBox from '../../components/individual/IndividualDashboardBox'

const DashboardIndividual = () => {
  return (
    <AdminLayout>
      <AdminContentLayout>
        <IndividualDashboardBox />
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default DashboardIndividual
